import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { EDLogo } from './EDLogo';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-ed-black/80 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-360">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-361">
        <EDLogo data-id="element-362" />

        <a href="#whatsapp" className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-full border border-zinc-700 hover:border-ed-green/50 hover:bg-ed-green/5 transition-all text-sm font-medium text-white group" data-id="element-363">
          <MessageCircle className="w-4 h-4 text-zinc-400 group-hover:text-ed-green transition-colors" data-id="element-364" />
          <span data-id="element-365">Consultas</span>
        </a>
      </div>
    </nav>;
}